import { Toaster } from 'react-hot-toast';
import Router from './pages/Router';

function App() {
    return (
        <div className="h-screen text-sm bg-yellow-50">
            <Router />
            <Toaster position="top-right" reverseOrder={true} />
        </div>
    );
}

export default App;
